export default __webpack_public_path__ + "static/data-management-light-mode-9368e42fa804b8f3dd57caf0c9b4eff7.png";